import { Menu, MenuItem } from '@mui/material';

export default function ClientActionsMenu({
  anchorEl,
  open,
  onClose,
  onClientActions,
  clientId,
  status,
  row,
  w9CopyExists,
}) {
  return (
    <Menu id="client-actions-menu" anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={() => onClientActions('showCredentials', clientId, status, row)}
      >
        <img src={'/assets/icons8-eye 1.png'} alt="" height={'20px'} width={'20px'} style={{ marginRight: '8px' }} />
        View Client Credentials
      </MenuItem>
      <MenuItem
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={() => onClientActions('resetClientPassword', clientId, status, row)}
      >
        <img
          src={'/assets/icons8-lock_orientation 2.png'}
          alt=""
          height={'20px'}
          width={'20px'}
          style={{ marginRight: '8px' }}
        />
        Reset Password
      </MenuItem>
      <MenuItem
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={() => onClientActions('showContracts', clientId, status, row)}
      >
        <img
          src={'/assets/icons8-download 1.png'}
          alt=""
          height={'20px'}
          width={'20px'}
          style={{ marginRight: '8px' }}
        />
        See Agreements
      </MenuItem>
      <MenuItem
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={() => onClientActions('createContract', clientId, status, row)}
      >
        <img
          src={'/assets/icons8-create-64.png'}
          alt=""
          height={'20px'}
          width={'20px'}
          style={{ marginRight: '8px' }}
        />
        Create Agreement
      </MenuItem>
      {w9CopyExists && (
        <MenuItem
          style={{ display: 'flex', alignItems: 'center' }}
          onClick={() => onClientActions('downloadW9Copy', clientId, status, row)}
        >
          <img
            src={'/assets/icons8-download 1.png'}
            alt=""
            height={'20px'}
            width={'20px'}
            style={{ marginRight: '8px' }}
          />
          Download W9 Copy
        </MenuItem>
      )}
      <MenuItem
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={() => onClientActions('editAccount', clientId, status, row)}
      >
        <img src={'/assets/icons8-edit 1.png'} alt="" height={'20px'} width={'20px'} style={{ marginRight: '8px' }} />
        Edit
      </MenuItem>
      <MenuItem
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={() => onClientActions('lockAccount', clientId, status, row)}
      >
        <img src={'/assets/icons8-lock 1.png'} alt="" height={'20px'} width={'20px'} style={{ marginRight: '8px' }} />
        {status === 'Active' ? 'Lock' : 'Unlock'}
      </MenuItem>
    </Menu>
  );
}
